import React from 'react';
import { Link } from 'react-router-dom';
import { MdWorkOutline, MdTrendingUp, MdSecurity, MdHelpOutline, MdLightbulbOutline } from 'react-icons/md';
import HeroCarousel from '../../components/public/HeroCarousel';
import '../../styles/vanguard.css';

const Home = () => {
    return (
        <div className="home-page">
            {/* Hero Carousel Banner - Vanguard Style */}
            <HeroCarousel />

            {/* Why Yathartha Exists - Image Cards */}
            <section className="vanguard-section gray-bg">
                <div className="vanguard-container">
                    <h2 className="vanguard-section-title">Which financial challenge can you overcome?</h2>
                    <div className="vanguard-image-cards-grid">
                        <div className="vanguard-image-card">
                            <img src="/Financially Secure.jpeg" alt="Feel Financially Secure" className="vanguard-image-card-img" />
                            <div className="vanguard-image-card-content">
                                <h3 className="vanguard-image-card-title">Feel Financially Secure</h3>
                                <p className="vanguard-image-card-description">
                                    Even if you earn well, understand your true financial position to build lasting security.
                                </p>
                                <Link to="/begin-with-clarity" className="vanguard-image-card-button">
                                    Financial diagnosis
                                </Link>
                            </div>
                        </div>

                        <div className="vanguard-image-card">
                            <img src="/Consistent Savings.jpeg" alt="Build Consistent Savings" className="vanguard-image-card-img" />
                            <div className="vanguard-image-card-content">
                                <h3 className="vanguard-image-card-title">Build Consistent Savings</h3>
                                <p className="vanguard-image-card-description">
                                    We'll help you create a disciplined savings plan so you don't have to worry about emergencies.
                                </p>
                                <Link to="/our-approach" className="vanguard-image-card-button">
                                    Savings strategy
                                </Link>
                            </div>
                        </div>

                        <div className="vanguard-image-card">
                            <img src="/Invest With Understanding.jpeg" alt="Invest With Understanding" className="vanguard-image-card-img" />
                            <div className="vanguard-image-card-content">
                                <h3 className="vanguard-image-card-title">Invest With Understanding</h3>
                                <p className="vanguard-image-card-description">
                                    Make informed investment decisions based on your goals, not emotions or trends.
                                </p>
                                <Link to="/our-approach" className="vanguard-image-card-button">
                                    planning
                                </Link>
                            </div>
                        </div>

                        <div className="vanguard-image-card">
                            <img src="/dept.png" alt="Reduce Debt Stress" className="vanguard-image-card-img" />
                            <div className="vanguard-image-card-content">
                                <h3 className="vanguard-image-card-title">Reduce Debt Stress</h3>
                                <p className="vanguard-image-card-description">
                                    Create a clear debt management plan to eliminate financial stress and build freedom.
                                </p>
                                <Link to="/our-approach" className="vanguard-image-card-button">
                                    management
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* What Is Yathartha - Split Layout */}
            <section className="vanguard-split-section">
                <div className="vanguard-split-container">
                    {/* Left Side - Title & Description */}
                    <div className="vanguard-split-left">
                        <h2>Yathartha services to support your financial journey</h2>
                        <p>
                            We offer a wide range of services to help you understand your financial reality and build a clear roadmap.
                        </p>
                        <Link to="/our-approach" className="vanguard-split-cta">
                            View all services
                        </Link>
                        <Link to="/begin-with-clarity" className="vanguard-split-link">
                            Start your financial diagnosis
                        </Link>
                    </div>

                    {/* Right Side - List Items */}
                    <div className="vanguard-split-right">
                        <Link to="/our-approach" className="vanguard-list-item">
                            <span className="vanguard-list-item-text">Financial Diagnosis</span>
                            <span className="vanguard-list-item-arrow">→</span>
                        </Link>
                        <Link to="/our-approach" className="vanguard-list-item">
                            <span className="vanguard-list-item-text">Clarity Report</span>
                            <span className="vanguard-list-item-arrow">→</span>
                        </Link>
                        <Link to="/our-approach" className="vanguard-list-item">
                            <span className="vanguard-list-item-text">Personal Roadmap</span>
                            <span className="vanguard-list-item-arrow">→</span>
                        </Link>
                        <Link to="/our-approach" className="vanguard-list-item">
                            <span className="vanguard-list-item-text">Discipline & Review</span>
                            <span className="vanguard-list-item-arrow">→</span>
                        </Link>
                        <Link to="/commitment" className="vanguard-list-item">
                            <span className="vanguard-list-item-text">Our Commitment</span>
                            <span className="vanguard-list-item-arrow">→</span>
                        </Link>
                        <Link to="/about" className="vanguard-list-item">
                            <span className="vanguard-list-item-text">About Yathartha</span>
                            <span className="vanguard-list-item-arrow">→</span>
                        </Link>
                    </div>
                </div>
            </section>

            {/* Our Approach - Featured Resources */}
            <section className="vanguard-resources-section">
                <div className="vanguard-resources-container">
                    <h2 className="vanguard-resources-title">Our Approach</h2>

                    {/* Featured Card */}
                    <div className="vanguard-featured-card">
                        <img src="/Financial.png" alt="Diagnosis before decisions" className="vanguard-featured-image" />
                        <div className="vanguard-featured-content">
                            <h3 className="vanguard-featured-title">Diagnosis before decisions</h3>
                            <p className="vanguard-featured-description">
                                We believe in understanding your complete financial reality before making any recommendations. Our comprehensive diagnosis reveals your true financial health.
                            </p>
                            <Link to="/our-approach" className="vanguard-featured-button">
                                Learn our approach
                            </Link>
                        </div>
                    </div>

                    {/* Resource Cards Grid */}
                    <div className="vanguard-resources-grid">
                        <div className="vanguard-resource-card">
                            <img src="/decisions copy.jpg" alt="Financial Diagnosis" className="vanguard-resource-image" />
                            <div className="vanguard-resource-content">
                                <h3 className="vanguard-resource-title">Financial Diagnosis</h3>
                                <p className="vanguard-resource-description">
                                    Complete analysis of your income, expenses, savings, debt, and investment readiness.
                                </p>
                                <Link to="/our-approach" className="vanguard-resource-link">
                                    Start diagnosis
                                </Link>
                            </div>
                        </div>

                        <div className="vanguard-resource-card">
                            <img src="/report.jpg" alt="Clarity Report" className="vanguard-resource-image" />
                            <div className="vanguard-resource-content">
                                <h3 className="vanguard-resource-title">Clarity Report</h3>
                                <p className="vanguard-resource-description">
                                    Easy-to-understand report showing what's working and what needs attention.
                                </p>
                                <Link to="/our-approach" className="vanguard-resource-link">
                                    View sample
                                </Link>
                            </div>
                        </div>

                        <div className="vanguard-resource-card">
                            <img src="/map.jpeg" alt="Personal Roadmap" className="vanguard-resource-image" />
                            <div className="vanguard-resource-content">
                                <h3 className="vanguard-resource-title">Personal Roadmap</h3>
                                <p className="vanguard-resource-description">
                                    Step-by-step financial plan aligned with your goals and values.
                                </p>
                                <Link to="/our-approach" className="vanguard-resource-link">
                                    Create roadmap
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Who Is Yathartha For */}
            <section className="vanguard-section gray-bg">
                <div className="vanguard-container">
                    <h2 className="vanguard-section-title pb-5">Who Is Yathartha For?</h2>
                    <div className="vanguard-audience-list">
                        <div className="vanguard-audience-item icon-card">
                            <div className="vanguard-audience-icon-wrapper">
                                <MdWorkOutline className="vanguard-audience-icon" />
                            </div>
                            <div className="vanguard-audience-text">Salaried professionals</div>
                        </div>
                        <div className="vanguard-audience-item icon-card">
                            <div className="vanguard-audience-icon-wrapper">
                                <MdTrendingUp className="vanguard-audience-icon" />
                            </div>
                            <div className="vanguard-audience-text">Business owners & entrepreneurs</div>
                        </div>
                        <div className="vanguard-audience-item icon-card">
                            <div className="vanguard-audience-icon-wrapper">
                                <MdSecurity className="vanguard-audience-icon" />
                            </div>
                            <div className="vanguard-audience-text">Families planning long-term security</div>
                        </div>
                        <div className="vanguard-audience-item icon-card">
                            <div className="vanguard-audience-icon-wrapper">
                                <MdHelpOutline className="vanguard-audience-icon" />
                            </div>
                            <div className="vanguard-audience-text">Individuals feeling financially confused or stressed</div>
                        </div>
                        <div className="vanguard-audience-item icon-card">
                            <div className="vanguard-audience-icon-wrapper">
                                <MdLightbulbOutline className="vanguard-audience-icon" />
                            </div>
                            <div className="vanguard-audience-text">Anyone who wants clarity before action</div>
                        </div>
                    </div>
                    <p className="vanguard-section-intro vanguard-mt-2">If you want <strong className="vanguard-strong">truth over hype</strong>, Yathartha is for you.</p>
                </div>
            </section>

            {/* What Makes Yathartha Different */}
            {/* <section className="vanguard-section">
                <div className="vanguard-container">
                    <h2 className="vanguard-section-title">What Makes Yathartha Different</h2>
                    <div className="vanguard-diff-list">
                        <div className="vanguard-diff-item">✔ Diagnosis before advice</div>
                        <div className="vanguard-diff-item">✔ Reality-based planning</div>
                        <div className="vanguard-diff-item">✔ No product or commission bias</div>
                        <div className="vanguard-diff-item">✔ Simple, structured, human approach</div>
                        <div className="vanguard-diff-item">✔ Focus on awareness and discipline</div>
                        <div className="vanguard-diff-item">✔ Long-term thinking, not quick fixes</div>
                    </div>
                    <div className="vanguard-tagline-box">
                        <p>Yathartha doesn't sell dreams.</p>
                        <p><strong className="vanguard-strong">It builds foundations.</strong></p>
                    </div>
                </div>
            </section> */}

            {/* Our Belief */}
            {/* <section className="vanguard-section light-blue-bg">
                <div className="vanguard-container">
                    <h2 className="vanguard-section-title">Our Belief</h2>
                    <div className="vanguard-grid">
                        <div className="vanguard-card">

                            <p className="vanguard-card-text">Financial clarity creates confidence</p>
                        </div>
                        <div className="vanguard-card">

                            <p className="vanguard-card-text">Awareness precedes abundance</p>
                        </div>
                        <div className="vanguard-card">

                            <p className="vanguard-card-text">Discipline creates freedom</p>
                        </div>
                        <div className="vanguard-card">
                            <p className="vanguard-card-text">Money should support life—not control it</p>
                        </div>
                        <div className="vanguard-card">

                            <p className="vanguard-card-text">Right decisions come from right understanding</p>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* Final CTA - Lead With Vision Style */}
            <section className="vanguard-final-cta-new">
                <div className="vanguard-cta-new-container">
                    {/* Left Side - Title */}
                    <div className="vanguard-cta-new-left">
                        {/* <div className="vanguard-cta-accent-bar"></div> */}
                        <h2 className="vanguard-cta-new-title mt-5 pt-5 py-5">Your First Step Starts Here</h2>
                        <p className="vanguard-cta-new-subtitle">
                            You don't need to change everything today.<br />
                            You only need to <strong>see clearly</strong>.
                        </p>
                    </div>

                    {/* Right Side - Content */}
                    <div className="vanguard-cta-new-right">
                        <p className="vanguard-cta-new-description">
                            Every Financial Transformation Begins With Clarity. We Help You Understand Where You Are, Where You're Going, And What Steps To Take. Ensuring Every Decision Ties Back To Your True Financial Reality.
                        </p>

                        <div className="vanguard-cta-new-heading">WE HELP YOU DEFINE:</div>

                        <div className="vanguard-cta-new-cards">
                            <div className="vanguard-cta-new-card">
                                <span className="vanguard-cta-card-check">✓</span>
                                <span className="vanguard-cta-card-text">Begin with a simple Financial Diagnosis</span>
                            </div>
                            <div className="vanguard-cta-new-card vanguard-cta-card-active">
                                <span className="vanguard-cta-card-check">✓</span>
                                <span className="vanguard-cta-card-text">Understand your financial truth</span>
                            </div>
                            <div className="vanguard-cta-new-card">
                                <span className="vanguard-cta-card-check">✓</span>
                                <span className="vanguard-cta-card-text">Design your roadmap consciously</span>
                            </div>
                            <div className="vanguard-cta-new-card">
                                <span className="vanguard-cta-card-check">✓</span>
                                <span className="vanguard-cta-card-text">Build lasting financial security</span>
                            </div>
                        </div>

                        {/* Outcome Section */}
                        <div className="vanguard-cta-outcome">
                            <div className="vanguard-cta-outcome-label">OUTCOME</div>
                            <p className="vanguard-cta-outcome-text">
                                A Clear Financial Picture That Empowers You To Make Informed Decisions, Build Consistent Savings, And Achieve Long-Term Financial Freedom With Confidence.
                            </p>
                        </div>

                        {/* CTA Button */}
                        <Link to="/begin-with-clarity" className="vanguard-cta-new-button">
                            Start Your Financial Diagnosis Now →
                        </Link>

                        {/* Trust Badges */}
                        <div className="vanguard-cta-new-badges">
                            <span className="vanguard-cta-new-badge">100% Confidential</span>
                            <span className="vanguard-cta-new-badge">No Selling</span>
                            <span className="vanguard-cta-new-badge">Transparent</span>
                            <span className="vanguard-cta-new-badge">Your Best Interest First</span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
